import { scheduleOnce } from '@ember/runloop';
import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { isEmpty } from '@ember/utils';
import Ember from 'ember';
import config from 'garaje/config/environment';
import { getErrorDescription, getErrorDetail, getStatusCode } from 'garaje/utils/parse-error';

// Base class for section-scoped error substates (`<section>-error` pods).
// Same telemetry contract as the global error route (app/pods/error/route.js)
// so retry-recovery tracking in the application route keeps working, plus a
// `section` tag so outages can be sliced per feature in Datadog.
export default class SectionErrorRoute extends Route {
  @service metrics;
  @service online;
  @service router;
  @service sessionStorage;

  section = null;

  setupController(_controller, error) {
    super.setupController(...arguments);
    if (error instanceof Error) {
      this._handleTracking(error);
      /* eslint-disable ember/no-incorrect-calls-with-inline-anonymous-functions */
      scheduleOnce('afterRender', () => {
        if (config.environment !== 'test') {
          Ember.onerror(error);
        }
      });
      /* eslint-enable ember/no-incorrect-calls-with-inline-anonymous-functions */
    }
  }

  _handleTracking(error) {
    const props = {
      section: this.section,
      current_url: this.router.currentURL,
      http_status_code: getStatusCode(error),
      error_description: getErrorDescription(error),
      error_detail: getErrorDetail(error),
      online_status: this.online.status,
    };
    this.metrics.trackEvent('Error State Reached', props);
    // same event name as the global error route so existing Datadog monitors
    // keep firing; `section` in the payload is the discriminator
    this.metrics.logMonitorError({ event: 'ERROR_STATE_REACHED', debugExtras: props });
    const errorStateEnteredAt = this.sessionStorage.getItem('error_state_entered_at');
    if (isEmpty(errorStateEnteredAt)) {
      this.sessionStorage.setItem('error_state_entered_at', Date.now());
    }
  }
}
